export default {
  'contactCenterApprovePayee.singleComplete': '<%=name%> has been Approved',
  'contactCenterApprovePayee.complete': '<%=number%> Payee(s) Approved.',
  'contactCenterApprovePayee.error': 'Error! <%=number%> payee(s) failed to be approved.',
  'contactCenterApprovePayee.message': 'The following Payee(s) are being approved:',
  'contactCenterApprovePayee.title': 'Approve Payees'
};
